var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFivetofifty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.046 18.303a6.97 6.97 0 1 1 13.939 0 6.97 6.97 0 0 1-13.939 0zm6.97-4.025a4.026 4.026 0 1 0 0 8.052 4.026 4.026 0 0 0 0-8.052zM30.644 18.303a6.97 6.97 0 1 1 13.939 0 6.97 6.97 0 0 1-13.94 0zm6.97-4.025a4.026 4.026 0 1 0 0 8.051 4.026 4.026 0 0 0 0-8.051zM3.67 32.62h-.363v11.372a7.702 7.702 0 0 0 15.404 0V32.62H3.669zM1.33 30.644a3.307 3.307 0 0 1 2.339-.97h14.679a3.307 3.307 0 0 1 3.307 3.308v11.01a10.647 10.647 0 0 1-21.294 0v-11.01c0-.877.349-1.718.97-2.338zM30.263 32.62h-.362v11.372a7.702 7.702 0 1 0 15.404 0V32.62H30.263zm-2.338-1.976a3.307 3.307 0 0 1 2.338-.97h14.68a3.307 3.307 0 0 1 3.306 3.308v11.01a10.647 10.647 0 0 1-21.293 0v-11.01c0-.877.349-1.718.969-2.338z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.725
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.692 7.093c.606 0 1.098-.492 1.098-1.098V1.098a1.098 1.098 0 1 0-2.196 0v4.897c0 .606.491 1.098 1.098 1.098zM16.647 6.167a1.094 1.094 0 0 0 1.553-.002 1.098 1.098 0 0 0-.002-1.553l-4-3.992a1.098 1.098 0 1 0-1.552 1.554l4.001 3.993zM31.961 6.487c.28 0 .562-.107.776-.32l3.998-3.994A1.098 1.098 0 0 0 35.183.62l-3.998 3.993a1.098 1.098 0 0 0 .776 1.874z",
    fill: "#88A13B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivetofifty);
export default __webpack_public_path__ + "static/media/fivetofifty.8c73a0ecdf93b10d2cec2f78ff280683.svg";
export { ForwardRef as ReactComponent };